export class ConfirmRegistration {
    constructor (
        public Email: string = '',
        public ConfirmationCode: string = ''
    ) { }
}
